import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { Link } from 'react-router-dom';
import type { Order } from '../types';
import { timeAgo, formatUzs } from '../lib/format';

interface OrderCardProps {
  order: Order;
  disabled?: boolean;
}

export function OrderCard({ order, disabled = false }: OrderCardProps) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: order.id,
    data: { fromStatus: order.status },
    disabled,
  });

  return (
    <Link
      to={`/orders/${order.id}`}
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className={`order-card ${isDragging ? 'dragging' : ''}`}
      style={{
        transform: CSS.Translate.toString(transform),
        pointerEvents: isDragging ? 'none' : undefined,
        textDecoration: 'none',
        display: 'block',
        color: 'inherit',
      }}
      onClick={(e) => {
        if (isDragging) e.preventDefault();
      }}
    >
      <div className="order-card-plate">
        🚗 {order.car.plate}
      </div>
      <div className="order-card-client">
        👤 {order.client.name} · 📞 {order.client.phone}
      </div>
      <div className="order-card-problem">
        {order.problem}
      </div>
      <div className="order-card-meta">
        <span>{timeAgo(order.receivedAt)}</span>
        <span className="amount">{formatUzs(order.totalCached)}</span>
      </div>
    </Link>
  );
}
